import { useContext } from 'react';
import { NavBarContext } from './context';

export const useNavBar = () => {
  return useContext(NavBarContext);
};
